import React from 'react';

import './CardBox.scss';
import { ListFieldItem } from 'RLX/Forms/ListField';

class CardBox extends ListFieldItem {
  constructor (props) {
    super(props);
  }

  getClassName () {
    return 'CardBox';
  }

  getFields () {
    const { card } = this.props;
    const { propertyUpdaterFactory } = this;
    return [
      {
        label: 'Image URL',
        value: card.image,
        type: 'image',
        onChange: propertyUpdaterFactory('image', card)
      },
      {
        label: 'Title',
        icon: 'header',
        value: card.title,
        // className: 'half',
        type: 'text',
        onChange: propertyUpdaterFactory('title', card)
      },
      {
        label: 'Link to URL',
        icon: 'link',
        value: card.url,
        // className: 'half',
        type: 'text',
        onChange: propertyUpdaterFactory('url', card)
      },
      {
        label: 'Display as Logo',
        value: card.contain,
        icon: 'compress',
        type: 'toggle',
        onChange: propertyUpdaterFactory('contain', card)
      },
      card.contain ? null : {
        label: 'Image Positioning',
        value: card.imagePosition,
        icon: 'arrows',
        type: 'text',
        onChange: propertyUpdaterFactory('imagePosition', card)
      },
      {
        label: 'Card HTML/Content',
        icon: 'code',
        value: card.content,
        type: 'html',
        rows: 3,
        onChange: propertyUpdaterFactory('content', card)
      }
    ].filter(field => field)
  }
};

export default CardBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/CardBox/CardBox.jsx